module.exports = __webpack_public_path__ + "1a25f0ffcb350288972401902a69ff6b.svg";